import React from 'react'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'
import { createRoot } from 'react-dom/client'
import { persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'
import App from './App'
import history from './history'
import store from './redux/store'
import reportWebVitals from './reportWebVitals'
import './index.scss'

const persistor = persistStore(store)
const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Unable to find the root element')
}

createRoot(rootElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router history={history}>
          <App />
        </Router>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
